import { Pipe, PipeTransform } from '@angular/core';
import { NumeralService } from '../services/Numeral.service';

@Pipe({
  name: 'formatAmount',
  standalone: true
})
export class FormatAmountPipe implements PipeTransform{
  constructor(private numeralService: NumeralService) {
  }
  transform(value: any, format?): any {
    format = format ? format : '$0,0.00';
    if (!value){
      return this.numeralService.format(format, 0);
    } else {
      return this.numeralService.format(format, value);
    }
  }
}
